/**
 * Mobile buy bar: shown whenever the real COD button isn't on screen —
 * before the shopper reaches it as well as after scrolling past — so price,
 * CTA and "pay on delivery" are always one glance away. Hidden only while the
 * real button itself is visible, to avoid two identical CTAs at once. Plain
 * show/hide, no transition (see the note on fast scrolls below).
 */
(function () {
  function syncPrice(sticky) {
    var active = document.querySelector('dvtb-bundle-picker .st_bundle-box.active');
    if (!active) return;

    var price = active.querySelector('.st_discounted-price');
    var compare = active.querySelector('.st_compare-at-price');
    var priceEl = sticky.querySelector('[data-dvtb-sticky-price]');
    var compareEl = sticky.querySelector('[data-dvtb-sticky-compare]');
    var qtyEl = sticky.querySelector('[data-dvtb-sticky-qty]');

    if (priceEl && price) priceEl.textContent = price.textContent.trim();
    if (compareEl) {
      compareEl.textContent = compare ? compare.textContent.trim() : '';
      compareEl.hidden = !compare;
    }
    if (qtyEl && active.dataset.bundleBoxCount) {
      qtyEl.textContent = active.dataset.bundleBoxCount + ' unidades';
    }
  }

  function initStickySources() {
    document.querySelectorAll('[data-dvtb-cod-sticky-source]').forEach(function (source) {
      if (source.dataset.stickyBound) return;
      source.dataset.stickyBound = 'true';

      var sticky = document.getElementById(source.dataset.dvtbCodStickySource);
      if (!sticky) return;

      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          // Recomputed from scratch on every callback rather than toggled:
          // a fast scroll or an instant jump can skip clean past the moment
          // the button crosses the viewport edge, and a toggle would then
          // leave the bar stuck in the wrong state.
          var show = !entry.isIntersecting;
          if (show) syncPrice(sticky);
          sticky.hidden = !show;

          // Exposed for anything floating in the same bottom strip (WhatsApp
          // bubble, cookie banner) so it can sit above the bar, not over it.
          if (show) document.documentElement.style.setProperty('--dvtb-cod-sticky-h', sticky.offsetHeight + 'px');

          // The WhatsApp bubble shares this bottom corner — lift it above
          // the bar instead of hiding it, so support stays reachable.
          var whatsapp = document.querySelector('[data-dv-wa]');
          if (whatsapp) whatsapp.classList.toggle('dv-wa--above-sticky-cod', show);
        },
        { threshold: 0 },
      );
      observer.observe(source);

      document.addEventListener('dvtb:bundle-updated', function () {
        syncPrice(sticky);
      });
    });
  }

  /**
   * The bar never opens the drawer directly: clicking scrolls to the offer
   * tiers (same page, no URL change) so the shopper picks one; the real
   * button, now in view, is what opens the checkout drawer.
   */
  function initScrollToOffers() {
    document.querySelectorAll('[data-dvtb-cod-scroll-to-offers]').forEach(function (button) {
      if (button.dataset.scrollBound) return;
      button.dataset.scrollBound = 'true';
      button.addEventListener('click', function () {
        var offers = document.querySelector('dvtb-bundle-picker');
        if (offers) offers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickySources();
      initScrollToOffers();
    });
  } else {
    initStickySources();
    initScrollToOffers();
  }
  document.addEventListener('shopify:section:load', function () {
    initStickySources();
    initScrollToOffers();
  });
})();
